import { render, staticRenderFns } from "./domainCreate.vue?vue&type=template&id=4efbc4ad&"
import script from "./domainCreate.vue?vue&type=script&lang=js&"
export * from "./domainCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports